document.addEventListener('DOMContentLoaded', () => {
  const modal = document.querySelector('product-modal');
  if (!modal) return;

  const prevBtn = modal.querySelector('.product-media-modal__nav--prev');
  const nextBtn = modal.querySelector('.product-media-modal__nav--next');

  function getItems() {
    return Array.from(modal.querySelectorAll('.product-media-modal__item'));
  }

  let currentIndex = 0;
  let startX = 0;
  let endX = 0;

  function showSlide(index) {
    const items = getItems();
    if (!items.length) return;

    if (index < 0) index = items.length - 1;
    if (index >= items.length) index = 0;

    items.forEach((item, i) => {
      if (i === index) {
        item.classList.add('active');
        item.style.display = 'flex';
      } else {
        item.classList.remove('active');
        item.style.display = 'none';
      }
    });

    currentIndex = index;
  }

  function nextSlide(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    showSlide(currentIndex + 1);
  }

  function prevSlide(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    showSlide(currentIndex - 1);
  }

  function initModalGallery() {
    const items = getItems();
    if (!items.length) return;
    showSlide(0);
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', nextSlide);
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', prevSlide);
  }

  modal.addEventListener(
    'touchstart',
    (e) => {
      startX = e.changedTouches[0].screenX;
    },
    { passive: true }
  );

  modal.addEventListener(
    'touchend',
    (e) => {
      endX = e.changedTouches[0].screenX;
      const diff = endX - startX;

      if (Math.abs(diff) < 40) return;

      if (diff < 0) {
        nextSlide(e);
      } else {
        prevSlide(e);
      }
    },
    { passive: false }
  );

  document.querySelectorAll('.product__media-toggle, .product__modal-opener').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      setTimeout(() => {
        const mediaId = trigger.closest('[data-media-id]')?.getAttribute('data-media-id');
        const items = getItems();

        if (!items.length) return;

        const foundIndex = items.findIndex((item) => item.getAttribute('data-media-id') === mediaId);
        showSlide(foundIndex >= 0 ? foundIndex : 0);
      }, 100);
    });
  });

  initModalGallery();
});
/* =========================================================
   AURORA — MEDIR ANNOUNCEMENT BAR
   Sticky header + color del overscroll
   ========================================================= */

(() => {
  const updateAuroraAnnouncementBar = () => {
    const section = document.querySelector('.announcement-bar-section');

    if (!section) return;

    const utilityBar =
      section.querySelector('.utility-bar') || section;

    const height = section.offsetHeight;

    const background =
      window.getComputedStyle(utilityBar).backgroundColor;

    document.documentElement.style.setProperty(
      '--aurora-announcement-height',
      `${height}px`
    );

    document.documentElement.style.setProperty(
      '--aurora-announcement-bg',
      background
    );
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      updateAuroraAnnouncementBar
    );
  } else {
    updateAuroraAnnouncementBar();
  }

  window.addEventListener(
    'resize',
    updateAuroraAnnouncementBar
  );
})();
/* =========================================================
   AURORA — COLOR INFERIOR DE SAFARI
   Footer al llegar al final de la página
   ========================================================= */

(() => {
  let ticking = false;

  const getBackground = (element) => {
    if (!element) return null;

    const color =
      window.getComputedStyle(element).backgroundColor;

    return color;
  };

  const updateBottomBrowserColor = () => {
    ticking = false;

    const footer =
      document.querySelector('footer.footer');

    const announcement =
      document.querySelector('.announcement-bar-section .utility-bar');

    if (!footer) return;

    const footerColor =
      getBackground(footer) || '#E9D3CE';

    const announcementColor =
      getBackground(announcement) || '#6F2D3A';

    const docHeight = Math.max(
      document.documentElement.scrollHeight,
      document.body.scrollHeight
    );

    const viewportBottom =
      window.scrollY + window.innerHeight;

    const distanceFromBottom =
      docHeight - viewportBottom;

    const atBottom =
      distanceFromBottom <= 80;

    const color =
      atBottom
        ? footerColor
        : announcementColor;

    document.documentElement.style.setProperty(
      'background-color',
      color,
      'important'
    );

    document.body.style.setProperty(
      'background-color',
      color,
      'important'
    );

    const themeColor =
      document.querySelector(
        'meta[name="theme-color"]'
      );

    if (themeColor) {
      themeColor.setAttribute(
        'content',
        color
      );
    }
  };

  const requestUpdate = () => {
    if (ticking) return;

    ticking = true;

    requestAnimationFrame(
      updateBottomBrowserColor
    );
  };

  window.addEventListener(
    'scroll',
    requestUpdate,
    { passive: true }
  );

  window.addEventListener(
    'resize',
    requestUpdate
  );

  window.addEventListener(
    'pageshow',
    requestUpdate
  );

  document.addEventListener(
    'DOMContentLoaded',
    requestUpdate
  );

  requestUpdate();
})();